import * as S from "./styles";

const LOGO = "writé";

const Header = ({ score, combo, multiplier, wave, wpm, accuracy }) => {
  return (
    <S.Header>
      <S.Left>
        {typeof wave === "number" ? (
          <S.Chip>
            <span>WAVE</span>
            <strong>{wave}</strong>
          </S.Chip>
        ) : null}
        {typeof combo === "number" && combo > 0 ? (
          <S.Chip $highlight>
            <span>COMBO</span>
            <strong>{combo}</strong>
            {multiplier > 1 ? <S.Mult>×{multiplier}</S.Mult> : null}
          </S.Chip>
        ) : null}
      </S.Left>
      <div className="logo">
        {LOGO.split("").map((letter, i) => (
          <div key={i}>{letter}</div>
        ))}
      </div>
      <S.Right>
        {typeof wpm === "number" ? (
          <S.MiniStat>
            <span>WPM</span>
            <strong>{wpm}</strong>
          </S.MiniStat>
        ) : null}
        {typeof accuracy === "number" ? (
          <S.MiniStat>
            <span>ACC</span>
            <strong>{accuracy}%</strong>
          </S.MiniStat>
        ) : null}
        {typeof score === "number" ? (
          <S.Score>
            <span>SCORE</span>
            <strong>{score}</strong>
          </S.Score>
        ) : null}
      </S.Right>
    </S.Header>
  );
};

export default Header;
